export default __webpack_public_path__ + "static/media/success.7d646087.png";